import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
const fileBrowserApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getFiles: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser`,
                params: { path: data.path },
            }),
        }),
        getComponentInfo: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser/${data.fileId}`,
            }),
        }),
        getComponentIssues: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser/${data.fileId}/issues`,
            }),
        }),
        getComponentVulnerabilities: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser/${data.fileId}/vulnerabilities`,
            }),
        }),
        getComponentDependencies: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser/${data.fileId}/dependencies`,
            }),
        }),
        getComponentSecrets: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser/${data.fileId}/secrets`,
            }),
        }),
        getComponentBehavior: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser/${data.fileId}/behavior`,
            }),
        }),
        getComponentActions: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser/${data.fileId}/actions`,
            }),
        }),
        getComponentSignatures: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser/${data.fileId}/signatures`,
            }),
        }),
        getComponentNetworking: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.reportId}/file-browser/${data.fileId}/networking`,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetFilesQuery, useGetComponentInfoQuery, useGetComponentIssuesQuery, useGetComponentVulnerabilitiesQuery, useGetComponentDependenciesQuery, useGetComponentSecretsQuery, useGetComponentBehaviorQuery, useGetComponentActionsQuery, useGetComponentSignaturesQuery, useGetComponentNetworkingQuery, } = fileBrowserApi;
//# sourceMappingURL=fileBrowser.api.js.map